import {Card, Icon} from '@blueprintjs/core';
import {Link} from 'react-router-dom';

export default function Main() {
     const menu = [
          {id: 'employee', path: '/employee', icon: 'people', title: 'Manajemen Karyawan'}
          // {id: 'attendance', path: '/attendance', icon: 'time', title: 'Manajemen Absensi'}
     ];
     return (
          <div className="content-wrapper">
               <div className="menu-wrapper">
                    {menu.map((e, i) => (
                         <Link key={i} to={e.path}>
                              <Card className="bp5-interactive menu-item">
                                   <Icon size={60} icon={e.icon} />
                                   <br />
                                   <div className="menu-footer">{e.title}</div>
                              </Card>
                         </Link>
                    ))}
               </div>
          </div>
     );
}
